(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8343],{

/***/ 7869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _MeeyImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3524);




const RANDOM_AVATART_COLOR = [
    {
        background: "#F1F8FF",
        color: "#366FEB"
    },
    {
        background: "#FFF7E1",
        color: "#F3960A"
    },
    {
        background: "#EFFEE9",
        color: "#08A822"
    },
    {
        background: "#F4F2FF",
        color: "#7163CB"
    },
    {
        background: "#FFF0ED",
        color: "#E35B47"
    },
    {
        background: "#ECFFFC",
        color: "#0AB1BC"
    },
    {
        background: "#FDF3E0",
        color: "#865931"
    },
    {
        background: "#FFECFB",
        color: "#830897"
    },
    {
        background: "#FEFFD9",
        color: "#749C02"
    },
    {
        background: "#ECF8FF",
        color: "#005B90"
    }
];
const existingUser = [];
const AvatarWithName = (param)=>{
    let { src , alt , name , subTitle , textClass , avatarOnly , className , subTitleClass , imageClass , imageProps , ...otherProps } = param;
    const [mounted, setMounted] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const randomItem = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        const existing = existingUser.find((item)=>item.name === name);
        if (existing) return existing.setting;
        else {
            const setting = RANDOM_AVATART_COLOR[Math.floor(Math.random() * RANDOM_AVATART_COLOR.length)];
            existingUser.push({
                name: "".concat(name),
                setting
            });
            return setting;
        }
    }, [
        name
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setMounted(true);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("flex items-center ", className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex-[0_0_auto] rounded-full border border-[rgba(0,0,0,0.05)]",
                children: src ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_MeeyImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("rounded-full w-9 h-9 object-cover ", imageClass),
                    src: src,
                    resizeOptions: {
                        width: 32,
                        height: 32
                    },
                    alt: alt || "".concat(name),
                    ...imageProps
                }) : mounted ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("rounded-full w-9 h-9 object-cover flex items-center justify-center text-fs-14 ", imageClass),
                    style: {
                        background: randomItem.background,
                        color: randomItem.color
                    },
                    children: typeof name === "string" ? name.substring(0, 1) : ""
                }) : null
            }),
            !avatarOnly && name || subTitle ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex-[1_1_auto] overflow-hidden ml-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("text-gray break-word w-full overflow-hidden", textClass),
                        children: name
                    }),
                    subTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("text-gray mt-1 w-full", subTitleClass),
                        children: subTitle
                    })
                ]
            }) : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AvatarWithName);


/***/ }),

/***/ 3524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _constants_environment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7181);
/* harmony import */ var _constants_file__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32336);
/* harmony import */ var _utils_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77325);




const MeeyImage = (param)=>{
    let { src , alt , className , resizeOptions , resizeOnFly =true , id , ssr =true , lazyloadClassName ="w-full h-full overflow-hidden"  } = param;
    const { width =320 , height =180 , resizingType ="fill-down" , gravity ="ce" , watermark  } = resizeOptions !== null && resizeOptions !== void 0 ? resizeOptions : {};
    const imageSrc = resizeOnFly ? src.match(_constants_file__WEBPACK_IMPORTED_MODULE_2__/* .fileType.resizeImageSupport */ .r.resizeImageSupport) ? (0,_utils_image__WEBPACK_IMPORTED_MODULE_3__/* .resizeOnFlyUrl */ .Li)({
        uri: src,
        width,
        height,
        resizingType,
        gravity,
        watermark
    }) : _constants_environment__WEBPACK_IMPORTED_MODULE_1__/* .MEDIA_URL */ .eR + src : src;
    // console.log(imageSrc);
    return ssr ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        id: id,
        className: className,
        alt: alt,
        width: width ? width : "100%",
        height: height ? height : "100%",
        src: imageSrc,
        onError: (param)=>{
            let { currentTarget  } = param;
            currentTarget.onerror = null; // prevents looping
            currentTarget.src = _constants_environment__WEBPACK_IMPORTED_MODULE_1__/* .STATIC_DOMAIN */ .xm + "/images/default_avatar_project.jpg";
        }
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
};
/* harmony default export */ __webpack_exports__["Z"] = (MeeyImage);


/***/ }),

/***/ 20951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_PopOver; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/vendor/click-outside/index.ts + 3 modules
var click_outside = __webpack_require__(23199);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js + 8 modules
var CSSTransition = __webpack_require__(79281);
;// CONCATENATED MODULE: ./src/components/PopOver/PopOverClickTrigger.tsx
// @ts-nocheck





const PopOverClickTrigger = (param)=>{
    let { wrapperClassName , className , children , content , dropdownClassName , open , position ="bottom-left" , onClose , onOpen  } = param;
    const nodeRef = (0,react.useRef)(null);
    const [isOpen, setIsOpen] = (0,react.useState)(open);
    const triggerRef = (0,react.useRef)();
    const [styleOverlay, setStyleOverlay] = (0,react.useState)({
        top: 0,
        left: 0
    });
    (0,react.useEffect)(()=>{
        setIsOpen(!!open);
    }, [
        open
    ]);
    const handleUpdatePosition = (0,react.useCallback)(()=>{
        if (!triggerRef.current) return;
        const bounding = triggerRef.current.getBoundingClientRect();
        if (position === "left-top") {
            setStyleOverlay({
                top: bounding.top,
                left: bounding.left,
                transform: "translate(".concat(-100, "%, calc(").concat(-100, "% + ").concat(bounding.height, "px))")
            });
        }
        if (position === "top-right") {
            setStyleOverlay({
                top: bounding.top,
                left: bounding.left,
                transform: "translate(calc(".concat(0, "% + ").concat(bounding.width, "px), calc(").concat(-100, "% + ").concat(bounding.height, "px))")
            });
        }
        if (position === "bottom-left") {
            setStyleOverlay({
                top: bounding.top,
                left: bounding.left,
                transform: "translate(calc(".concat(-100, "% + ").concat(bounding.width, "px), calc(", 0, "% + ").concat(bounding.height, "px))")
            });
        }
        if (position === "bottom-right") {
            setStyleOverlay({
                top: bounding.top,
                left: bounding.left,
                transform: "translate(0, calc(".concat(0, "% + ").concat(bounding.height, "px))")
            });
        }
    }, [
        position
    ]);
    (0,react.useEffect)(()=>{
        handleUpdatePosition();
        window.addEventListener("resize", handleUpdatePosition);
        window.addEventListener("scroll", handleUpdatePosition);
        return ()=>{
            window.removeEventListener("resize", handleUpdatePosition);
            window.removeEventListener("scroll", handleUpdatePosition);
        };
    }, [
        handleUpdatePosition,
        isOpen,
        position
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(click_outside/* default */.Z, {
        active: isOpen,
        onClick: ()=>{
            if (open === undefined) setIsOpen(!isOpen);
            onClose && onClose();
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)("meey-popover", wrapperClassName),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: triggerRef,
                    className: (0,clsx_m/* default */.Z)("text-gray popover-trigger cursor-pointer flex justify-between items-center  rounded", className),
                    onClick: ()=>{
                        if (open === undefined) setIsOpen(!isOpen);
                        if (isOpen) onClose && onClose();
                        else onOpen && onOpen();
                    },
                    children: children
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CSSTransition/* default */.Z, {
                    in: isOpen,
                    nodeRef: nodeRef,
                    timeout: 200,
                    unmountOnExit: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            ...styleOverlay
                        },
                        className: (0,clsx_m/* default */.Z)("popover-overlay p-4", isOpen ? "popover-overlay-open" : "", "popover-overlay-".concat(position), dropdownClassName),
                        children: content
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var PopOver_PopOverClickTrigger = (PopOverClickTrigger);

;// CONCATENATED MODULE: ./src/components/PopOver/PopOverHoverTrigger.tsx



const PopOverHoverTrigger = (param)=>{
    let { className , children , content , dropdownClassName , position ="bottom-left" , open , onOpen , onClose , wrapTriggerClassName  } = param;
    const [isOpen, setIsOpen] = (0,react.useState)(open);
    const triggerRef = (0,react.useRef)();
    const [styleOverlay, setStyleOverlay] = (0,react.useState)({
        top: 0,
        left: 0
    });
    (0,react.useEffect)(()=>{
        setIsOpen(open);
    }, [
        open
    ]);
    const handleUpdatePosition = (0,react.useCallback)(()=>{
        if (!triggerRef.current) return;
        const bounding = triggerRef.current.getBoundingClientRect();
        if (position === "left-top") {
            setStyleOverlay({
                top: bounding.top,
                left: bounding.left,
                transform: "translate(".concat(-100, "%, calc(").concat(-100, "% + ").concat(bounding.height, "px))")
            });
        }
        if (position === "left-bottom") {
            setStyleOverlay({
                top: bounding.top,
                left: bounding.left,
                transform: "translate(calc(".concat(-100, "% - 12px ), calc(", 0, "% + ", 0, "px))")
            });
        }
        if (position === "top-left") {
            setStyleOverlay({
                top: bounding.top,
                left: bounding.left,
                transform: "translate(calc(".concat(0, "%  ), calc(").concat(-50, "% - ").concat(bounding.height, "px))")
            });
        }
        if (position === "top-right") {
            setStyleOverlay({
                top: bounding.top,
                left: bounding.left,
                transform: "translate(calc(".concat(0, "% + ").concat(bounding.width, "px), calc(").concat(-100, "% + ").concat(bounding.height, "px))")
            });
        }
        if (position === "bottom-left") {
            setStyleOverlay({
                top: bounding.top,
                left: bounding.left,
                transform: "translate(calc(".concat(-100, "% + ").concat(bounding.width, "px), calc(", 0, "% + ").concat(bounding.height, "px))")
            });
        }
        if (position === "bottom-right") {
            setStyleOverlay({
                top: bounding.top,
                left: bounding.left,
                transform: "translate(0, calc(".concat(0, "% + ").concat(bounding.height + 20, "px))")
            });
        }
    }, [
        position
    ]);
    (0,react.useEffect)(()=>{
        handleUpdatePosition();
        window.addEventListener("resize", handleUpdatePosition);
        window.addEventListener("scroll", handleUpdatePosition);
        return ()=>{
            window.removeEventListener("resize", handleUpdatePosition);
            window.removeEventListener("scroll", handleUpdatePosition);
        };
    }, [
        handleUpdatePosition,
        isOpen,
        position
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)("meey-popover", className),
        onMouseOver: ()=>{
            setIsOpen(true);
            onOpen && onOpen();
        },
        onMouseOut: ()=>{
            setIsOpen(false);
            onClose && onClose();
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)("popover-trigger", wrapTriggerClassName),
                onClick: onOpen,
                ref: triggerRef,
                children: children
            }),
            isOpen && content ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    ...styleOverlay
                },
                className: (0,clsx_m/* default */.Z)("popover-overlay", isOpen ? "popover-overlay-open" : "", "popover-overlay-".concat(position), dropdownClassName),
                children: content
            }) : null
        ]
    });
};
/* harmony default export */ var PopOver_PopOverHoverTrigger = (PopOverHoverTrigger);

;// CONCATENATED MODULE: ./src/components/PopOver/index.tsx



const PopOver = (props)=>{
    const { trigger ="click"  } = props;
    switch(trigger){
        case "click":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PopOver_PopOverClickTrigger, {
                ...props
            });
        case "hover":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PopOver_PopOverHoverTrigger, {
                ...props
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PopOver_PopOverClickTrigger, {
                ...props
            });
    }
};
/* harmony default export */ var components_PopOver = (PopOver);


/***/ }),

/***/ 84536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hooks_useAuth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33172);
/* harmony import */ var _utils_datetime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61297);
/* harmony import */ var _AvatarWithName__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7869);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40364);
/* harmony import */ var _PopOver__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20951);






const PopupAvatarUser = ()=>{
    const { user , logout  } = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_1__/* .useAuth */ .a)();
    return user ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PopOver__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            trigger: "click",
            dropdownClassName: "mt-2 !p-3 rounded ",
            content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: " bg-white rounded flex flex-col items-center justify-center w-[11rem]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AvatarWithName__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        imageProps: {
                            resizeOnFly: false
                        },
                        src: user.avatar ? user.avatar : null,
                        name: user.name,
                        avatarOnly: true,
                        imageClass: "!w-16 !h-16",
                        className: "mb-2 ",
                        textClass: "!text-white font-medium select-none"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "font-semibold text-fs-14 text-center",
                        children: user.name
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "text-fs-12 text-grey-500 mb-4",
                        children: [
                            "Tham gia ",
                            (0,_utils_datetime__WEBPACK_IMPORTED_MODULE_2__/* .formatDate */ .p6)(user.createdDate, "DD/MM/YYYY")
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        btnType: "filled",
                        color: "secondary",
                        type: "button",
                        onClick: logout,
                        className: "px-3 py-2 w-full justify-center text-fs-14",
                        children: "Đăng xuất"
                    })
                ]
            }),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AvatarWithName__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    imageProps: {
                        resizeOnFly: false
                    },
                    src: user.avatar ? user.avatar : null,
                    name: user.name,
                    avatarOnly: true,
                    textClass: "!text-white font-medium select-none"
                })
            })
        })
    }) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (PopupAvatarUser);


/***/ }),

/***/ 65037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _constants_environment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7181);
/* harmony import */ var _constants_project_constant__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18825);
/* harmony import */ var _hooks_useAuth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33172);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6154);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _AvatarWithName__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7869);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_infinite_scroll_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58533);
/* harmony import */ var _utils_datetime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61297);











const NotiItem = (param)=>{
    let { data , updateSeen , onClose  } = param;
    const { largeIcon , contents , isSeen , webUrl , updatedAt , _id , type  } = data;
    const { token  } = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_3__/* .useAuth */ .a)();
    const seenNoti = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(async (id)=>{
        if (token) try {
            await axios__WEBPACK_IMPORTED_MODULE_9__/* ["default"].request */ .Z.request({
                method: "POST",
                url: "/v1/notifications/seen",
                baseURL: _constants_environment__WEBPACK_IMPORTED_MODULE_1__/* .MEEY_REVIEW_API_URL */ .HG,
                data: {
                    _id: id
                },
                headers: {
                    Authorization: "Bearer ".concat(token)
                }
            });
            updateSeen && updateSeen();
        } catch (error) {} finally{}
    }, [
        token,
        updateSeen
    ]);
    const getUrlType = (type)=>{
        switch(type){
            case 1:
                return "/images/noti-type/review.svg";
            case 2:
                return "/images/noti-type/question.svg";
            case 3:
                return "/images/noti-type/reply.svg";
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("flex gap-2 py-3  cursor-pointer  duration-300 px-4 hover:bg-blue-50 ", !isSeen ? "bg-[#F6F8FB]" : ""),
        onClick: ()=>{
            seenNoti(_id);
            onClose && onClose();
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
                href: webUrl,
                title: webUrl,
                className: "flex gap-2 flex-1",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "relative flex-0 flex items-center ",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "relative h-fit",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AvatarWithName__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    src: (largeIcon === null || largeIcon === void 0 ? void 0 : largeIcon.uri) ? largeIcon === null || largeIcon === void 0 ? void 0 : largeIcon.uri : (largeIcon === null || largeIcon === void 0 ? void 0 : largeIcon.url) ? largeIcon === null || largeIcon === void 0 ? void 0 : largeIcon.url : _constants_project_constant__WEBPACK_IMPORTED_MODULE_2__/* .DEFAULT_IMAGE_URI */ .mG,
                                    imageProps: {
                                        resizeOnFly: (largeIcon === null || largeIcon === void 0 ? void 0 : largeIcon.uri) ? true : false,
                                        resizeOptions: {
                                            width: 56,
                                            height: 56
                                        }
                                    },
                                    imageClass: "!w-14 !h-14",
                                    className: " flex-0"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "absolute bottom-0 right-0",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: _constants_environment__WEBPACK_IMPORTED_MODULE_1__/* .STATIC_DOMAIN */ .xm + getUrlType(type),
                                        alt: "type"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex-1 text-gray-800",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "line-clamp-3",
                                dangerouslySetInnerHTML: {
                                    __html: contents
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-grey-500 text-fs-12",
                                children: (0,_utils_datetime__WEBPACK_IMPORTED_MODULE_8__/* .getRelativeTime */ .ni)(updatedAt)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex-0 flex items-center",
                onClick: (e)=>{
                    e.stopPropagation();
                    seenNoti(_id);
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("w-3 h-3 rounded-full ", isSeen ? "bg-transparent" : "bg-blue-500")
                })
            })
        ]
    });
};
const NotificationPopupContent = (param)=>{
    let { allowBack , titleClassName , onBack , onClose  } = param;
    var _dataNoti_results;
    const { token  } = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_3__/* .useAuth */ .a)();
    const [hasMore, setHasMore] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(true);
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    const [dataNoti, setDataNoti] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)({
        totalResults: 0,
        results: []
    });
    const getData = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(async ()=>{
        setLoading(true);
        if (token) try {
            const { data  } = await axios__WEBPACK_IMPORTED_MODULE_9__/* ["default"].request */ .Z.request({
                method: "POST",
                url: "/v1/notifications",
                baseURL: _constants_environment__WEBPACK_IMPORTED_MODULE_1__/* .MEEY_REVIEW_API_URL */ .HG,
                headers: {
                    Authorization: "Bearer ".concat(token)
                }
            });
            setDataNoti({
                ...data
            });
            setHasMore(data.totalResults > 0);
        } catch (error) {} finally{
            setLoading(false);
        }
    }, [
        token
    ]);
    const getMore = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(async ()=>{
        if (token) try {
            const { data  } = await axios__WEBPACK_IMPORTED_MODULE_9__/* ["default"].request */ .Z.request({
                method: "POST",
                url: "/v1/notifications",
                baseURL: _constants_environment__WEBPACK_IMPORTED_MODULE_1__/* .MEEY_REVIEW_API_URL */ .HG,
                data: {
                    lastid: dataNoti.results[dataNoti.results.length - 1]._id
                },
                headers: {
                    Authorization: "Bearer ".concat(token)
                }
            });
            setDataNoti({
                ...dataNoti,
                results: [
                    ...dataNoti.results,
                    ...data.results
                ]
            });
            setHasMore(data.totalResults > 0);
        } catch (error) {}
    }, [
        dataNoti,
        token
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        getData();
    }, [
        getData
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("text-fs-24 font-bold px-4 pt-4 pb-2 w-full flex items-center", titleClassName),
                children: [
                    allowBack ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "mrv mrv-arrow_back mr-2 cursor-pointer",
                        onClick: onBack
                    }) : null,
                    " ",
                    "Th\xf4ng b\xe1o"
                ]
            }),
            loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full h-[40rem] flex items-center justify-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "dot-flashing"
                })
            }) : dataNoti.totalResults ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full h-full overflow-auto pb-12 md:pb-0",
                id: "scrollableNotiPopup",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_infinite_scroll_component__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    dataLength: (dataNoti === null || dataNoti === void 0 ? void 0 : (_dataNoti_results = dataNoti.results) === null || _dataNoti_results === void 0 ? void 0 : _dataNoti_results.length) || 0,
                    next: getMore,
                    scrollableTarget: "scrollableNotiPopup",
                    hasMore: hasMore,
                    loader: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "px-4 flex items-center justify-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "dot-flashing"
                        })
                    }),
                    children: dataNoti === null || dataNoti === void 0 ? void 0 : dataNoti.results.map((e)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NotiItem, {
                            data: e,
                            onClose: onClose,
                            updateSeen: ()=>{
                                setDataNoti({
                                    ...dataNoti,
                                    results: dataNoti.results.map((item)=>item._id === e._id ? {
                                            ...item,
                                            isSeen: true
                                        } : item)
                                });
                            }
                        }, e._id))
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full h-full flex-1 flex flex-col items-center px-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "mrv mrv-notifications text-[100px] text-grey-100 mt-16"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-fs-18 font-semibold",
                        children: "Chưa c\xf3 th\xf4ng b\xe1o n\xe0o!"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-center text-fs-14 text-grey-400 mb-32",
                        children: "H\xe3y chia sẻ quan điểm về dự \xe1n hoặc tương t\xe1c, c\xe1c th\xf4ng b\xe1o li\xean quan sẽ hiển thị tại đ\xe2y."
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NotificationPopupContent);


/***/ }),

/***/ 19534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VideoPlayer */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var video_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85215);
/* harmony import */ var video_js_dist_video_js_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32090);
/* harmony import */ var video_js_dist_video_js_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(video_js_dist_video_js_css__WEBPACK_IMPORTED_MODULE_3__);





const VideoPlayer = (props)=>{
    const videoRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const playerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    // const [playing, setPlaying] = useState(false);
    // const [ready, setReady] = useState(false);
    // const [currentSeek, setCurrentSeek] = useState(0);
    const { options , onReady , className  } = props;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        // Make sure Video.js player is only initialized once
        if (!playerRef.current) {
            // The Video.js player needs to be _inside_ the component el for React 18 Strict Mode.
            const videoElement = document.createElement("video-js");
            videoElement.classList.add("vjs-big-play-centered");
            videoRef.current.appendChild(videoElement);
            const player = playerRef.current = (0,video_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(videoElement, {
                ...options,
                controlBar: {
                    fullscreenToggle: true
                }
            }, ()=>{
                // setReady(true);
                onReady && onReady(player);
            });
        // You could update an existing player in the `else` block here
        // on prop change, for example:
        } else {
            const player1 = playerRef.current;
            player1.autoplay(options.autoplay);
        // player.src(options.sources);
        }
    }, [
        onReady,
        options,
        videoRef
    ]);
    // Dispose the Video.js player when the functional component unmounts
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const player = playerRef.current;
        player.player().on("play", ()=>{
        // setPlaying(true);
        });
        player.player().on("pause", ()=>{
        // setPlaying(false);
        });
        player.player().on("timeupdate", ()=>{
        // setCurrentSeek(player.currentTime());
        });
        return ()=>{
            if (player && !player.isDisposed()) {
                player.dispose();
                playerRef.current = null;
            }
        };
    }, [
        playerRef
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("w-full h-full  relative embed-video", className),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full h-full absolute video-embed flex items-center",
                ref: videoRef
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (VideoPlayer);


/***/ }),

/***/ 61297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p6": function() { return /* binding */ formatDate; },
  "ni": function() { return /* binding */ getRelativeTime; },
  "qE": function() { return /* binding */ secondToHourString; }
});

// UNUSED EXPORTS: FORMAT_DATE, FORMAT_DATE_VN, convertSecondToString, convertStringToDate, filterListHourString, getEndOfTime, getMinutesByDay, getStartOfTime, initDate, isPreviousScheduleTimes, isPreviousTime, schedulerDateDiff, subtractDuration

;// CONCATENATED MODULE: ./src/constants/date.ts
const DATE_VI = "DD/MM/YYYY";
const MIN_DATE_FILTER = new Date(2019, 1, 1);
const DATE_FORMAT = {
    DAY_ONLY_SLASH: "DD/MM/YYYY",
    TIME_DAY_ONLY_SLASH: "HH:mm DD/MM/YYYY"
};

// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/dayjs/locale/vi.js
var vi = __webpack_require__(37553);
// EXTERNAL MODULE: ./src/utils/number.ts + 1 modules
var number = __webpack_require__(1495);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/relativeTime.js
var relativeTime = __webpack_require__(84110);
var relativeTime_default = /*#__PURE__*/__webpack_require__.n(relativeTime);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/updateLocale.js
var updateLocale = __webpack_require__(70660);
var updateLocale_default = /*#__PURE__*/__webpack_require__.n(updateLocale);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/localeData.js
var localeData = __webpack_require__(96036);
var localeData_default = /*#__PURE__*/__webpack_require__.n(localeData);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/weekday.js
var weekday = __webpack_require__(6833);
var weekday_default = /*#__PURE__*/__webpack_require__.n(weekday);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/customParseFormat.js
var customParseFormat = __webpack_require__(10285);
var customParseFormat_default = /*#__PURE__*/__webpack_require__.n(customParseFormat);
;// CONCATENATED MODULE: ./src/utils/datetime.ts









dayjs_min_default().locale("vi");
dayjs_min_default().extend((relativeTime_default()));
dayjs_min_default().extend((updateLocale_default()));
dayjs_min_default().extend((weekday_default()));
dayjs_min_default().extend((localeData_default()));
dayjs_min_default().extend((customParseFormat_default()));
const FORMAT_DATE = "DD-MM-YYYY";
const FORMAT_DATE_VN = "DD/MM/YYYY";
const getRelativeTime = (date)=>{
    const seconds = Math.abs(dayjs_min_default()(date).diff(new Date(), "seconds"));
    const minutes = Math.abs(dayjs_min_default()(date).diff(new Date(), "minutes"));
    if (seconds < 1) {
        return "Vừa xong";
    }
    // (Ngày giờ hiện tại - ngày đăng tin)<60 giây: hiển thị định dạng x giây trước
    if (minutes < 1) {
        return "".concat(seconds, " gi\xe2y trước");
    }
    const oneHour = 60;
    // (Ngày giờ hiện tại - ngày đăng tin)<60 phút: hiển thị định dạng x phút trước
    if (minutes < oneHour) {
        return "".concat(minutes, " ph\xfat trước");
    }
    const oneDay = oneHour * 24;
    // 24 tiếng> (Giờ hiện tại - thời gian tạo) >= 60 phút: hiển thị định dạng x tiếng trước
    if (minutes >= oneHour && minutes < oneDay) {
        return "".concat((0,number/* roundDown */.Sf)(minutes / oneHour), " tiếng trước");
    }
    // 30 ngày > (Giờ hiện tại - thời gian tạo) >= 24 tiếng: hiển thị định dạng x ngày trước
    if (minutes >= oneDay && minutes <= 30 * oneDay) {
        return "".concat((0,number/* roundDown */.Sf)(minutes / oneDay), " ng\xe0y trước");
    }
    return dayjs_min_default()(date).format(DATE_VI);
};
const getMinutesByDay = (date)=>{
    return Math.abs(dayjs(date).diff(new Date(), "minutes"));
};
const subtractDuration = (date, value, unit)=>dayjs(date).subtract(value, unit);
const formatDate = (input, format)=>{
    if (!input) return null;
    return dayjs_min_default()(input).format(format);
};
const convertStringToDate = (input, format)=>{
    if (!input) return null;
    return dayjs(input, format).toDate();
};
const isPreviousTime = (dateOne, dateTwo, unit)=>dayjs(dateOne).isBefore(dateTwo, unit);
const convertSecondToString = (second)=>{
    if (second < 60) {
        return "Dưới 1 ph\xfat";
    }
    if (second < 3600) {
        return "".concat(Math.floor(second / 60), " ph\xfat");
    }
    if (second < 60 * 60 * 60) {
        return "".concat(Math.floor(second / 3600), " giờ");
    }
    return "Dưới 1 tuần";
};
const initDate = (date, format)=>dayjs(date, format);
const getStartOfTime = (date, unit)=>dayjs(date).startOf(unit);
const getEndOfTime = (date, unit)=>dayjs(date).endOf(unit);
const isPreviousScheduleTimes = (scheduleTimes)=>{
    const sortedTimes = [
        ...scheduleTimes
    ].sort((a, b)=>a - b);
    const lastTime = sortedTimes[sortedTimes.length - 1];
    return isPreviousTime(dayjs.unix(lastTime), dayjs(), "day");
};
// cal diff day between unix timestamp input && current day
const schedulerDateDiff = (timestamp, date)=>{
    const inputDate = dayjs.unix(timestamp);
    const formattedInputDate = inputDate.format("YYYY-MM-DD");
    const currentFormattedDate = (date !== null && date !== void 0 ? date : dayjs()).format("YYYY-MM-DD");
    const diffDay = dayjs(formattedInputDate).diff(dayjs(currentFormattedDate), "day");
    return diffDay;
};
const filterListHourString = (data)=>{
    const currentDate = dayjs().format("YYYY-MM-DD");
    return data.filter((value)=>{
        return dayjs("".concat(currentDate, " ").concat(value === null || value === void 0 ? void 0 : value.use)).valueOf() > dayjs().valueOf();
    });
};
const secondToHourString = function(_seconds) {
    let offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "colon";
    const seconds = Math.round(_seconds + offset);
    const hours = Math.floor(seconds / 3600);
    const divirsForMinutes = seconds % 3600;
    const minutes = Math.floor((seconds - hours * 3600) / 60);
    const endSeconds = Math.ceil(divirsForMinutes % 60);
    const hourString = hours.toString();
    const minuteString = minutes < 10 ? "0".concat(minutes) : minutes.toString();
    const secondString = Number(endSeconds) < 10 ? "0".concat(endSeconds) : endSeconds.toString();
    switch(type){
        case "string":
            return "".concat(hourString, "h ").concat(minuteString, "m ").concat(secondString, "s");
        case "colon":
            return hours > 0 ? "".concat(hourString, ":").concat(minuteString, ":").concat(secondString) : "".concat(minuteString, ":").concat(secondString);
        default:
            return hours > 0 ? "".concat(hourString, ":").concat(minuteString, ":").concat(secondString) : "".concat(minuteString, ":").concat(secondString);
    }
};


/***/ }),

/***/ 1495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uf": function() { return /* binding */ formatNumber; },
  "kE": function() { return /* binding */ isNumeric; },
  "Sf": function() { return /* binding */ roundDown; }
});

// UNUSED EXPORTS: castToFloat, castToNumber, randomArrayNumber, roundNumber, roundUp

;// CONCATENATED MODULE: ./src/utils/string.ts
const removeSpecialCharacter = (str)=>{
    str = "".concat(str);
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    str = str.replace(/đ/g, "d");
    str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
    str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
    str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
    str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
    str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
    str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
    str = str.replace(/Đ/g, "D");
    return str;
};
const removeAlphabets = (str)=>{
    return str.replace(/[^.\d]/g, "");
};
const isAllUpperCase = (str)=>{
    const input = str ? str.toString() : null;
    return input ? !/[a-z]/.test(input) && /[A-Z]/.test(input) : false;
};
const isAllLowerCase = (str)=>{
    const input = str ? str.toString() : null;
    return input ? /[a-z]/.test(input) && !/[A-Z]/.test(input) : false;
};
const hidePhoneNumber = (phoneNumber, length)=>{
    return phoneNumber.slice(0, -length) + "***";
};
const truncateString = (str, maxLength, ellipsis)=>{
    if (str && str.length > maxLength) {
        return str.slice(0, maxLength) + (ellipsis || "...");
    }
    return str;
};
const capitalizeFirstLetter = (str)=>{
    if (!str || !str.length) {
        return null;
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const isStringEmpty = (str)=>{
    return !str || str.length === 0;
};

;// CONCATENATED MODULE: ./src/utils/number.ts


const roundDown = (num, decimal)=>{
    const pow = Math.pow(10, decimal ? decimal : 0);
    return Math.floor(num * pow) / pow;
};
const roundUp = (num, decimal)=>{
    const pow = Math.pow(10, decimal ? decimal : 0);
    return decimal && decimal > 0 ? Math.round(num * pow) / pow : Math.round(num);
};
const roundNumber = (input)=>{
    if (!input) return null;
    const number = Number(input);
    if (number % MIN_ROUND_NUMBER === 0) return number;
    return Math.round(number);
};
const isNumeric = (value)=>{
    return /^-?\d+$/.test(value);
};
const castToNumber = (num)=>{
    if (!num) return 0;
    if (Number.isNaN(Number(num))) return 0;
    return Number(num);
};
const castToFloat = (num, thousandSeparate, decimalSeparate)=>{
    if (!num) return null;
    if (!Number.isNaN(Number(num))) return Number(num);
    const numFormatted = num.toString().replace(thousandSeparate !== null && thousandSeparate !== void 0 ? thousandSeparate : ".", " ").replace(decimalSeparate !== null && decimalSeparate !== void 0 ? decimalSeparate : ",", ".");
    if (Number.isNaN(parseFloat(numFormatted))) return null;
    return parseFloat(numFormatted);
};
const formatNumber = (value)=>{
    return value ? "".concat(removeSpecialCharacter(removeAlphabets(value.toString()))).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "0";
};
const randomArrayNumber = (length)=>{
    return Array.from({
        length: length
    }, ()=>Math.floor(Math.random() * length));
};


/***/ }),

/***/ 23199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ click_outside; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/vendor/click-outside/is-in-dom.js
function isInDom(obj) {
    return Boolean(obj.closest("body"));
}

;// CONCATENATED MODULE: ./src/vendor/click-outside/has-parent.js

function hasParent(element, root) {
    return root && root.contains(element) && isInDom(element);
}

;// CONCATENATED MODULE: ./src/vendor/click-outside/click-outside.tsx


const ClickOutside = (param)=>{
    let { active =true , onClick , children  } = param;
    const innerRef = (0,react.useRef)();
    const handleClick = (event)=>{
        if (!hasParent(event.target, innerRef === null || innerRef === void 0 ? void 0 : innerRef.current)) {
            if (typeof onClick === "function") {
                onClick(event);
            }
        }
    };
    (0,react.useEffect)(()=>{
        if (active) {
            document.addEventListener("mouseup", handleClick, {
                passive: true
            });
        }
        return ()=>{
            if (active) {
                document.removeEventListener("mouseup", handleClick);
            }
        };
    });
    return /*#__PURE__*/ react.cloneElement(children, {
        ref: innerRef
    });
};
/* harmony default export */ var click_outside = (ClickOutside);

;// CONCATENATED MODULE: ./src/vendor/click-outside/index.ts



/***/ }),

/***/ 77027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "dg": function() { return /* binding */ lockScroll; },
  "pX": function() { return /* binding */ unlockScroll; }
});

// UNUSED EXPORTS: default, key, toggleScrollLock

;// CONCATENATED MODULE: ./src/vendor/scroll-locker/util/index.ts
/**
 * Test usage export. Do not use in your production
 */ function util_isBodyOverflowing() {
    return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}

// EXTERNAL MODULE: ./node_modules/zustand/esm/index.mjs + 1 modules
var esm = __webpack_require__(64529);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
;// CONCATENATED MODULE: ./src/store/scroll-locker-store.ts


const scroll_locker_store_useScrollLockerStore = (0,esm/* default */.ZP)((set, get)=>({
        lock: (container)=>{
            set((0,immer_esm/* default */.ZP)((state)=>{
                state[container] = {
                    show: true
                };
            }));
        },
        unlock: (container)=>{
            set((0,immer_esm/* default */.ZP)((state)=>{
                state[container] = {
                    show: false
                };
            }));
        }
    }));
/* harmony default export */ var scroll_locker_store = ((/* unused pure expression or super */ null && (scroll_locker_store_useScrollLockerStore)));

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/vendor/scroll-locker/Dom/canUseDom.ts
function canUseDom() {
    return !!( true && window.document && window.document.createElement);
}

;// CONCATENATED MODULE: ./src/vendor/scroll-locker/hooks/useLayoutEffect.ts


/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ const useLayoutEffect_useLayoutEffect =  true && canUseDom() ? react.useLayoutEffect : react.useEffect;
/* harmony default export */ var hooks_useLayoutEffect = ((/* unused pure expression or super */ null && (useLayoutEffect_useLayoutEffect)));
const useLayoutUpdateEffect = (callback, deps)=>{
    const firstMountRef = React.useRef(true);
    useLayoutEffect_useLayoutEffect(()=>{
        if (!firstMountRef.current) {
            return callback();
        }
    }, deps);
    // We tell react that first mount has passed
    useLayoutEffect_useLayoutEffect(()=>{
        firstMountRef.current = false;
        return ()=>{
            firstMountRef.current = true;
        };
    }, []);
};

;// CONCATENATED MODULE: ./src/vendor/scroll-locker/useScrollLocker.tsx




const key = {
    category: "category",
    keyword: "keyword",
    typeOfHouse: "type-of-house",
    location: "location",
    price: "price",
    area: "area",
    project: "project",
    filterMore: "filter-more",
    saveFilter: "save-filter",
    drawer: "drawer",
    favorite: "favorite",
    compare: "compare",
    sort: "sort",
    projectStatus: "project-status"
};
function useScrollLocker(container, turnOffLockScreen) {
    const { lock: lockScroll , unlock  } = useScrollLockerStore();
    const [opened, setOpened] = useState(false);
    const getContainer = useScrollLockerStore((state)=>state)[container] || {};
    const store = useScrollLockerStore((state)=>state);
    const onLockBodyScroll = ()=>{
        const scrollbarSize = window.innerWidth - document.body.offsetWidth;
        const isOverflow = isBodyOverflowing();
        document.body.style.setProperty("overflow", "hidden", "important");
        if (isOverflow) {
            document.body.style.paddingRight = "".concat(scrollbarSize, "px");
        }
    };
    const onUnLockBodyScroll = ()=>{
        const isOverflow = Object.values(store).some((value)=>{
            return typeof value !== "function" && (value === null || value === void 0 ? void 0 : value.show);
        });
        if (!isOverflow) {
            document.body.style.overflow = "";
            setTimeout(()=>{
                document.body.style.paddingRight = "";
            }, 300);
        } else {
            onLockBodyScroll();
        }
    };
    useLayoutEffect(()=>{
        if (!turnOffLockScreen) {
            if (getContainer && getContainer.show) {
                onLockBodyScroll();
            } else {
                onUnLockBodyScroll();
            }
            return ()=>onUnLockBodyScroll();
        }
    }, [
        getContainer
    ]);
    const onOpen = ()=>{
        setOpened(true);
        lockScroll(container);
    };
    const onClose = ()=>{
        setOpened(false);
        unlock(container);
    };
    return {
        onClose,
        onOpen,
        opened
    };
}
const toggleScrollLock = ()=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const store = useScrollLockerStore((state)=>state);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { lock: lockScroll , unlock  } = useScrollLockerStore();
    const onLockBodyScroll = ()=>{
        const scrollbarSize = window.innerWidth - document.body.offsetWidth;
        const isOverflow = isBodyOverflowing();
        document.body.style.setProperty("overflow", "hidden", "important");
        if (!isOverflow) {
            document.body.style.paddingRight = "".concat(scrollbarSize, "px");
        }
    };
    const onUnLockBodyScroll = ()=>{
        const isOverflow = Object.values(store).some((value)=>{
            return typeof value !== "function" && (value === null || value === void 0 ? void 0 : value.show);
        });
        if (!isOverflow) {
            document.body.style.overflow = "";
            setTimeout(()=>{
                document.body.style.paddingRight = "";
            }, 300);
        }
    };
    const disableBodyScroll = (container)=>{
        if (!store[container] || !store[container].show) {
            lockScroll(container);
            onLockBodyScroll();
        }
    };
    const enableBodyScroll = (container)=>{
        if (store[container] && store[container].show) {
            unlock(container);
            onUnLockBodyScroll();
        }
    };
    return {
        enableBodyScroll,
        disableBodyScroll
    };
};
const lockScroll = ()=>{
    const scrollbarSize = window.innerWidth - document.body.offsetWidth;
    const isOverflow = util_isBodyOverflowing();
    // document.body.style.position = "fixed";
    // document.body.style.width = "100vw";
    if (isOverflow) {
        document.body.style.paddingRight = "".concat(scrollbarSize, "px");
        // document.body.style.touchAction = "none";
        document.body.style.overflow = "hidden";
    }
};
const unlockScroll = ()=>{
    document.body.style.overflow = "auto";
    document.body.style.paddingRight = "0px";
// document.body.style.touchAction = "auto";
// document.body.style.position = "static";
// document.body.style.width = "auto";
};


/***/ }),

/***/ 25893:
/***/ (function() {

/* (ignored) */

/***/ })

}]);